import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErrorMsg } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mv_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("mv_user", JSON.stringify(r.data));
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("mv_token", r.data.token);
      localStorage.setItem("mv_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErrorMsg(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("mv_token");
    localStorage.removeItem("mv_user");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
